import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../../app.settings';


@Injectable({
  providedIn: 'root'
})
export class AudioService {
  
  audioUrl = `${AppSettings.API_ENDPOINT}/${'get-speech-recognition-list'}`;
  transcriptUrl = `${AppSettings.API_ENDPOINT}/${'new-transcription'}`;
  questionsUrl = `${AppSettings.API_ENDPOINT}/${'new-question-and-answers'}`;
  connectionRecordUrl = `${AppSettings.API_ENDPOINT}/${'nps-records'}`;
  updateSpeakerUrl = `${AppSettings.API_ENDPOINT}/${'update-transcription'}`;
  upateTranscriptUrl = `${AppSettings.API_ENDPOINT}/${'update-transcription'}`;
  qaMetricsUrl =`${AppSettings.API_ENDPOINT}/${'get-qa-metrics'}`;
  qaMetricsUpdateUrl = `${AppSettings.API_ENDPOINT}/${'update-qa-metrics'}`;
  deleteRecordUrl = `${AppSettings.API_ENDPOINT}/${'delete'}`;
  infogetTopicUrl = `${AppSettings.API_ENDPOINT}/${'get-topic/1'}`;
  infoUpdateUrl = `${AppSettings.API_ENDPOINT}/${'update-audio-file'}`;
  audioFileUrl = `${AppSettings.API_ENDPOINT}/${'download_audio'}`;
  keywordSearchUrl = `${AppSettings.API_ENDPOINT}/${'get-speech-recognition-list-by-transcript'}`;
  updateAwsTranscriptUrl = `${AppSettings.API_ENDPOINT}/${'get-aws-translate'}`;
  sendMailUrl = `${AppSettings.API_ENDPOINT}/${'send-email'}`;
  translateUrl_1 = `${AppSettings.API_ENDPOINT}/${'get-transcription-text'}`;
  translateUrl_2 = `${AppSettings.API_ENDPOINT}/${'translate'}`;

  constructor(private http: HttpClient) { }
  
  postAudio(data:any){
    return this.http.post(this.audioUrl, data);
  }

  getTranscriptData(id:string,role:any){
      return this.http.get(`${this.transcriptUrl}/${id}/${role}`);
  }

  getQuestionData(questionId:any,role:any){
    return this.http.get(`${this.questionsUrl}/${questionId}/${role}`);
  }

  getConnectionRecordData(questionId:any,role:any){
    return this.http.get(`${this.connectionRecordUrl}/${questionId}/${role}`);
  }

  updateSpeakerName(id:string, data:any){
    return this.http.post(`${this.updateSpeakerUrl}/${id}`,data);
  }

  updateTranscription(id:string, data:any){
   return this.http.post(`${this.upateTranscriptUrl}/${id}`, data)
  }

  getQAMetric(id:string){
    return this.http.post(this.qaMetricsUrl, id);
  }

  updateQAMetricsManual(data:any){
    return this.http.post(this.qaMetricsUpdateUrl, data);
  }

  deleteRecord(data:any){
    return this.http.post(this.deleteRecordUrl, data);
  }

  getInfo(){
    return this.http.get(this.infogetTopicUrl);
  }

  updateInfo(data:any){
    return this.http.post(this.infoUpdateUrl, data);
  }

  getAudioFile(id:string){
    return this.http.get(`${this.audioFileUrl}/${id}`, {responseType: 'blob' as 'json'});
  }

  postSearchKeyword(data:any){
    return this.http.post(this.keywordSearchUrl, data);
  }

  updateAwsTranscript(data:any){
     return this.http.post(this.updateAwsTranscriptUrl, data);
  }

  sendMail(data:any){
    return this.http.post(this.sendMailUrl, data);
  }

  getTranscriptionOriginalText(id:string){
    return this.http.get(`${this.translateUrl_1}/${id}/audio`);
  }

  getTranslatedLanguageData(data:any){
    return this.http.post(this.translateUrl_2, data);
  }

  
}
